import React, { useState, useEffect } from "react";
import { Grid, TextField, Button } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import checkListActions from "../../../redux/actions/checkList";

export default function Search() {
  const [search, setSearch] = useState("");
  const checkList = useSelector((state) => state.checkLists);
  const dispatch = useDispatch();

  useEffect(() => setSearch(checkList.search), [checkList.search]);

  const handleSubmit = () => {
    dispatch(checkListActions.setSearch({ search }));
  };
  return (
    <Grid
      container
      alignItems="center"
      spacing={2}
      style={{ marginBottom: 10 }}
    >
      <Grid item>
        <TextField
          variant="outlined"
          margin="dense"
          placeholder="nombre admin, nombre punto gira, nombre monitor gira"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          style={{ height: 40, marginTop: 3 }}
          onClick={() => handleSubmit()}
          startIcon={<SearchIcon />}
        >
          Buscar
        </Button>
      </Grid>
    </Grid>
  );
}
